<template>
    <div class="content-left">
        <div class="image-box">
            <el-upload
                class="avatar-uploader"
                ref="upload"
                :action="actionUrl"
                :headers="headers"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess"
                :disabled="!btnStatus.btnEditTeam"
                accept="image/png, image/jpeg, image/jpg"
                >
                <img v-if="teamData.imgUrl" :src="teamData.imgUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </div>
        <p>
            <el-tag size="mini">
                {{$t('teamDetail.TDMC')}}
            </el-tag>
            <span class="team-name nowrap vertical_align" :title="teamData.teamName" v-if="!isModifyTeamName">{{ teamData.teamName }}</span>
            <el-input v-else v-model="teamName" @blur="$parent.saveTeam(teamName); isModifyTeamName = false" size="mini" maxlength="20" :placeholder="$t('teamDetail.QSRXDTDMC')" style="width: 150px"></el-input>
            <span v-show="btnStatus.btnEditTeam" class="icon-modify el-icon-edit-outline" @click="()=>{ isModifyTeamName ? $parent.saveTeam(teamName) : '';  isModifyTeamName = !isModifyTeamName} "></span>
        </p>
        <p>
            <el-tag size="mini">
                {{$t('teamDetail.DZXM')}}
            </el-tag>
            <span class="leader-name nowrap vertical_align" :title="teamData.leaderName">
                {{ teamData.leaderName }}
            </span>
        </p>
        <p>
            <el-tag size="mini">
                {{$t('teamDetail.TDZT')}}
            </el-tag>
            <span class="status-text vertical_align" :class="{red: teamData.createStatus == 0, green: teamData.createStatus != 0}">
                {{ teamData.createStatus == 0 ? $t('teamDetail.ZJZ') : ( teamData.createStatus == 2 ? $t('teamDetail.JXZ') : $t('teamDetail.YJX')) }}
            </span>
        </p>
    </div>
</template>
<script>
import fetch from '@/api/fetch'
export default {
    name: 'contentLift',
    data(){
        return {
            teamName: '',
            isModifyTeamName: false,
        }
    },
    props:{
        teamData: {
            type: Object,
            default: ()=>({})
        },
        btnStatus: Object
    },
    watch: {
        teamData(newVal){
            if(newVal.teamName){
                this.teamName = this.teamData.teamName
            }
        }
    },
    computed: {
        headers() {
            return {
                authorization: "bearer " + sessionStorage.getItem('token')
            };
        },
        actionUrl() {
            return fetch.fileUploadImage
        }
    },
    methods:{
        handleAvatarSuccess(res) {
            this.teamData.imgUrl = res.data.imagePath;
            this.$parent.saveTeam()
        },
        beforeAvatarUpload(file) {
            if(file.name.indexOf('+') !== -1) {
                this.$notify({ title: '文件名不能包含特殊字符（+）!', type: 'error', position: 'top-left' });
                return false
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.image-box{
    width: 240px;
    height: 240px;
    img{
        width: 240px;
        height: 240px;
    }
}
p{
    margin: 12px 0;
    @include flex();
    align-items: center;
    .team-name{
        margin: 0 8px 0 0;
        font-size: 16px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        color: #0D141E;
        letter-spacing: 2px;
        display: inline-block;
        width: 140px;
    }
    .icon-modify{
        color: #5397F7;
        font-size: 16px;
    }
    .icon-modify:hover{
        cursor: pointer;
        opacity: .8;
    }
    /deep/ .el-tag{
        margin-right: 16px;
    }
    .leader-name, .status-text{
        font-size: 14px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        color: #5D646E;
        display: inline-block;
        width: 160px;
    }
    .vertical_align{
        vertical-align: -2px;
    }
    .red{
        color: #F77981;
    }
    .green{
        color: #29CE42;
    }
}

</style>